import {actualStreetNameCheck} from "../../../property/helpers/generated_decription/generated_description";
import {ISchemaOfferDetailRating} from "./SchemaOfferDetailRating";

interface IOfferMinimumRequiredData {
    geo_point: {
        coordinates: [number, number];
    };
    id: number;
    name: string;
    slug: string;
    street_name: string;
    street_number: string;
    region: {
        full_name: string;
        name_declension_where: string;
    };
    stats: {
        distance_from_region: {
            center: boolean;
            region: string;
            distance: number;
        };
    } | null;
    type: number;
    vendor: {
        name: string;
        slug: string;
    };
}

type IOffer = ISchemaOfferDetailRating | IOfferMinimumRequiredData;

export const generateFallbackDescription = (offer: IOffer) => {
    const doesOfferHaveRealStreet = actualStreetNameCheck(offer.street_name);
    const showStreetName: boolean = !!offer.street_name && doesOfferHaveRealStreet;
    const offerAddress = `${offer.street_name} ${offer.street_number}`;

    return `Inwestycja ${offer.name} znajduje się ${offer.region.name_declension_where} ${showStreetName ? ", " : " "} ${showStreetName && offerAddress} ${
        offer.stats?.distance_from_region &&
        offer.stats.distance_from_region.distance > 0 &&
        ` (${offer.stats.distance_from_region.distance} km od ${offer.stats.distance_from_region.center ? `centrum` : ""} ${
            offer.stats.distance_from_region.region
        })`
    } `;
};
import {actualStreetNameCheck} from "../../../property/helpers/generated_decription/generated_description";
import {ISchemaOfferDetailRating} from "./SchemaOfferDetailRating";

interface IOfferMinimumRequiredData {
    geo_point: {
        coordinates: [number, number];
    };
    id: number;
    name: string;
    slug: string;
    street_name: string;
    street_number: string;
    region: {
        full_name: string;
        name_declension_where: string;
    };
    stats: {
        distance_from_region: {
            center: boolean;
            region: string;
            distance: number;
        };
    } | null;
    type: number;
    vendor: {
        name: string;
        slug: string;
    };
}

type IOffer = ISchemaOfferDetailRating | IOfferMinimumRequiredData;

export const generateFallbackDescription = (offer: IOffer) => {
    const doesOfferHaveRealStreet = actualStreetNameCheck(offer.street_name);
    const showStreetName: boolean = !!offer.street_name && doesOfferHaveRealStreet;
    const offerAddress = `${offer.street_name} ${offer.street_number}`;

    return `Inwestycja ${offer.name} znajduje się ${offer.region.name_declension_where} ${showStreetName ? ", " : " "} ${showStreetName && offerAddress} ${
        offer.stats?.distance_from_region &&
        offer.stats.distance_from_region.distance > 0 &&
        ` (${offer.stats.distance_from_region.distance} km od ${offer.stats.distance_from_region.center ? `centrum` : ""} ${
            offer.stats.distance_from_region.region
        })`
    } `;
};
